import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import budgetPlanningService from '../../../services/budgetPlanningService'
import { 
  DollarSign,
  CheckCircle,
  Clock,
  AlertTriangle,
  TrendingUp,
  Calendar,
  FileText,
  Award,
  BarChart3,
  Users
} from 'lucide-react'

const BudgetPlannings = () => {
  const navigate = useNavigate()
  const [dashboardData, setDashboardData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadDashboardData()
  }, [])

  const loadDashboardData = async () => {
    try {
      setLoading(true)
      const response = await budgetPlanningService.getBudgetPlanningStats()
      if (response.success) {
        setDashboardData(response.data)
      } else {
        if (!response._errorHandled) {
          toast.error(response.message || 'Failed to load dashboard data')
        }
      }
    } catch (error) {
      console.error('Error loading budget plannings dashboard data:', error)
      if (!error._errorHandled) {
        if (error.response) {
          toast.error(error.response.data?.message || 'Failed to load dashboard data')
        } else if (!error.request) {
          toast.error('Failed to load dashboard data')
        }
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="sales-dashboard">
      {/* Page Header */}
      <div className="page-header" style={{textAlign: 'left'}}>
        <div className="page-title" style={{textAlign: 'left', alignItems: 'flex-start'}}>
          <h1 style={{textAlign: 'left', margin: '0 0 4px 0'}}>Budget Planning</h1>
          <p style={{textAlign: 'left', margin: 0}}>Plan and track project budgets</p>
        </div>
      </div>

      {/* Key Metrics Grid */}
      <div className="dashboard-metrics-grid">
        <div className="metric-card revenue">
          <div className="metric-header">
            <div className="metric-icon">
              <DollarSign size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+12%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.totalBudgets || 0)}
          </div>
          <div className="metric-title">Total Budgets</div>
          <div className="metric-subtitle">All budget plans</div>
        </div>

        <div className="metric-card customers">
          <div className="metric-header">
            <div className="metric-icon">
              <CheckCircle size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+8%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.active || 0)}
          </div>
          <div className="metric-title">Active</div>
          <div className="metric-subtitle">Currently active</div>
        </div>

        <div className="metric-card churn">
          <div className="metric-header">
            <div className="metric-icon">
              <Clock size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+5%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.approved || 0)}
          </div>
          <div className="metric-title">Approved</div>
          <div className="metric-subtitle">Approved budgets</div>
        </div>

        <div className="metric-card burn">
          <div className="metric-header">
            <div className="metric-icon">
              <AlertTriangle size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+3%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.underReview || 0)}
          </div>
          <div className="metric-title">Under Review</div>
          <div className="metric-subtitle">Pending approval</div>
        </div>
      </div>

      {/* Transactions Grid */}
      <div className="projects-transactions-content" style={{ marginTop: '24px' }}>
        <div className="projects-transactions-header">
          <h2>Budget Planning Management</h2>
          <p>Track and manage all budget plans</p>
        </div>
        <div className="projects-transactions-grid">
          <div 
            className="projects-transaction-card" 
            onClick={() => navigate('/projects/budget-plannings/list')} 
            style={{ cursor: 'pointer' }}
          >
            <div className="projects-transaction-icon">
              <DollarSign size={24} />
            </div>
            <div className="projects-transaction-content">
              <h3>Budget Planning List</h3>
              <p>Create, view, and manage all budget plans</p>
              <div className="projects-transaction-count">
                {loading ? '...' : `${dashboardData?.totalBudgets || 0} Total`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BudgetPlannings

